import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-solid-svg-icons';
import { useAuth } from '../contexts/AuthContext';
import { 
  DashboardContainer, 
  MainContent, 
  LoadingSpinner, 
  ErrorMessage 
} from '../components/admin/AdminStyles';
import { AdminHeader } from '../components/admin/AdminHeader';
import { StatsCards } from '../components/admin/StatsCards';
import { BookingsTable } from '../components/admin/BookingsTable';
import { Toast } from '../components/admin/Toast';
import { ChangePasswordModal } from '../components/admin/ChangePasswordModal';
import { useAdminDashboard } from '../components/admin/useAdminDashboard';

export function AdminDashboard() {
  const { user, logout } = useAuth();
  const [isChangePasswordModalOpen, setIsChangePasswordModalOpen] = useState(false);
  const {
    bookings,
    isLoading,
    error,
    toastMessage,
    showToast,
    showToastMessage,
    handleStatusChange,
    handleDelete,
    getStatistics
  } = useAdminDashboard();

  const stats = getStatistics();

  const handleChangePasswordSuccess = (message: string) => {
    showToastMessage(message);
  };

  const handleChangePasswordError = (message: string) => {
    showToastMessage(message);
  };

  if (isLoading) {
    return (
      <DashboardContainer>
        <LoadingSpinner>
          <div className="spinner">
            <FontAwesomeIcon icon={faClock} />
          </div>
          <p>Chargement des réservations...</p>
        </LoadingSpinner>
      </DashboardContainer>
    );
  }

  return (
    <DashboardContainer>
      <Toast message={toastMessage} show={showToast} />
      
      <AdminHeader 
        userName={user?.name} 
        onLogout={logout}
        onChangePassword={() => setIsChangePasswordModalOpen(true)}
      />

      <MainContent>
        {error && <ErrorMessage>{error}</ErrorMessage>}
        
        <StatsCards stats={stats} />
        
        <BookingsTable 
          bookings={bookings}
          onStatusChange={handleStatusChange}
          onDelete={handleDelete}
        />
      </MainContent>

      <ChangePasswordModal
        isOpen={isChangePasswordModalOpen}
        onClose={() => setIsChangePasswordModalOpen(false)}
        onSuccess={handleChangePasswordSuccess}
        onError={handleChangePasswordError}
      />
    </DashboardContainer>
  );
}
